import React from "react";
import PublicNavbar from "../components/PublicNavbar";

export default function Rates() {
  return (
    <div 
      className="bg-cover bg-[50%_50%] bg-no-repeat font-sans"
      style={{ backgroundImage: "url('/newassets/v2.png')" }}
    >
      <PublicNavbar />

      <main className="max-w-7xl mx-auto px-4 pb-20">
        {/* Header Badge */}
        <div className="flex justify-center mt-0 mb-12">
          <div className="relative inline-block mt-10 lg:mt-20">
            <div className="absolute inset-0 bg-[#c5e153] translate-x-[-4px] translate-y-[6px] rounded-2xl md:rounded-[2rem]" />
            <div className="relative flex items-center gap-3 bg-[#074b85] text-white px-8 py-3 md:px-12 md:py-4 rounded-2xl md:rounded-[2rem] shadow-sm">
              <div className="flex-shrink-0">
                <img src="/newassets/icon 4.png" alt="Rates" className="w-6 h-6 md:w-8 md:h-8 object-contain" />
              </div>
              <span className="font-extrabold text-xl md:text-3xl tracking-tight uppercase">Rates</span>
            </div>
          </div>
        </div>

        {/* SINGLE CONSOLIDATED CARD */}
        <div className="bg-white rounded-xl overflow-hidden shadow-xl">

          <div className="grid grid-cols-1 lg:grid-cols-1 divide-y lg:divide-y-0 lg:divide-x divide-gray-100">
            
            {/* LEFT COLUMN */}
            <div className="flex flex-col">
              {/* Equipments Section */}
              <section>
                <div className="bg-[#ff8a00] text-white py-2 text-center font-black text-xl uppercase">Equipments</div>
                <div className="p-4 md:p-8 space-y-4">
                  <EquipmentRow icon="rapas.png" label="Paddle" />
                  <div className="pl-8 space-y-2">
                    <PricePill label="Branded" price="Php 150.00" unit="/per paddle (per hour)" />
                    <PricePill label="Non-branded" price="Php 100.00" unit="/per paddle (per hour)" />
                  </div>
                  <EquipmentRow icon="red.png" label="Balls (3pcs)" price="Php 100.00" unit="/per hour" />
                  <EquipmentRow icon="too well.png" label="Towel" price="Php 50.00" />
                  <EquipmentRow icon="camera.png" label="Ball Machine" price="Php 600.00" unit="/per hour" />
                  <EquipmentRow icon="gate.png" label="Locker Access" price="Php 50.00" unit="(for 3 hours)" />
                  <div className="pt-2 border-t border-gray-100">
                    <EquipmentRow icon="red.png" label="Ball Picker" price="Php 100.00" unit="/per hour" />
                  </div>
                </div>
              </section>

              {/* Tourist Package Section */}
              <section className="border-t border-gray-100 mt-auto">
                <div className="bg-[#ff8a00] text-white py-2 text-center font-black text-xl uppercase leading-tight">
                  Tourist and Short Stay Package
                  <span className="block text-[10px] font-bold">(for Checked in Guests)</span>
                </div>
                <div className="p-4 md:p-8 space-y-4">
                  <PackageRow icon="2x2.png" label="1 day Pass" sub="(2 hour slot)" price="Php 400.00" />
                  <PackageRow icon="2x2.png" label="3 day Pass" sub="(2 hour slot)" price="Php 1,000.00" />
                  <PackageRow icon="2x2.png" label="Weekly Pass" sub="(2 hour slot)" price="Php 2,000.00" />
                </div>
              </section>
            </div>

            {/* RIGHT COLUMN */}
            <div className="flex flex-col">
              {/* Weekdays Section */}
              <section>
                <div className="bg-[#ff8a00] text-white py-2 text-center font-black text-xl uppercase">Weekdays</div>
                <div className="p-4 md:p-8 space-y-8">
                  <CourtTimeRow label="Morning Peak Hours" time="(6:00 a.m. – 8:00 a.m.)" price="Php 600.00" />
                  <CourtTimeRow label="Off-Peak Hours" time="(8:01 a.m. – 4:00 p.m.)" price="Php 500.00" />
                  <CourtTimeRow label="Evening Peak Hours" time="(4:01 p.m. – 10:00 p.m.)" price="Php 600.00" />
                </div>
              </section>

              {/* Weekend Section */}
              <section className="border-t border-gray-100 mt-auto">
                <div className="bg-[#ff8a00] text-white py-2 text-center font-black text-xl uppercase">Weekends</div>
                <div className="p-4 md:p-8 space-y-8">
                  <CourtTimeRow label="Morning Peak Hours" time="(6:00 a.m. – 11:00 a.m.)" price="Php 600.00" />
                  <CourtTimeRow label="Off-Peak Hours" time="(11:01 a.m. – 4:00 p.m.)" price="Php 500.00" />
                  <CourtTimeRow label="Evening Peak Hours" time="(4:01 p.m. – 10:00 p.m.)" price="Php 600.00" />
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

/* ---------- UI Sub-Components ---------- */

function EquipmentRow({ icon, label, price, unit }) {
  return (
    <div className="flex justify-between items-center text-[#074b85]">
      <div className="flex items-center gap-2">
        <img src={`/newassets/${icon}`} alt="" className="w-5 h-5 object-contain" />
        <span className="font-extrabold text-sm md:text-base">{label}</span>
      </div>
      {price && <PricePill price={price} unit={unit} />}
    </div>
  );
}

function PricePill({ label, price, unit }) {
  return (
    <div className="flex items-center justify-between gap-4 w-full sm:w-auto">
      {label && <span className="font-bold text-[#074b85] text-sm">- {label}</span>}
      <div className="bg-[#c5e153] px-3 py-1 rounded-full flex items-baseline gap-1 min-w-[140px] justify-center shadow-sm">
        <span className="font-black text-[#074b85] text-sm">{price}</span>
        {unit && <span className="text-[9px] font-bold text-[#4a7a2a]">{unit}</span>}
      </div>
    </div>
  );
}

function CourtTimeRow({ label, time, price }) {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
      <div className="flex items-start gap-3">
        <img src="/newassets/oras.png" alt="" className="w-5 h-5 mt-1" />
        <div className="flex flex-col">
          <span className="font-black text-[#074b85] leading-none">{label}</span>
          <span className="text-[11px] font-bold text-gray-500 italic">{time}</span>
        </div>
      </div>
      <div className="bg-[#c5e153] px-4 py-1 rounded-full flex items-baseline gap-1 shadow-sm">
        <span className="font-black text-[#074b85]">{price}</span>
        <span className="text-[9px] font-bold text-[#4a7a2a]">/per hour</span>
      </div>
    </div>
  );
}

function PackageRow({ icon, label, sub, price }) {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-3">
        <img src={`/newassets/${icon}`} alt="" className="w-6 h-6" />
        <div className="flex flex-col">
          <span className="font-black text-[#074b85] uppercase text-sm leading-none">{label}</span>
          <span className="text-[10px] font-bold text-gray-400 italic">{sub}</span>
        </div>
      </div>
      <div className="bg-[#c5e153] px-4 py-1 rounded-full flex items-baseline gap-1 shadow-sm">
        <span className="font-black text-[#074b85]">{price}</span>
        <span className="text-[9px] font-bold text-[#4a7a2a]">/per court</span>
      </div>
    </div>
  );
}